export default {
  state: {
    meta: {},
    agencyList: [],
    cityList: [],
    provinceList: [],

    genderList: [],
    ethnoList: [],
    ageList: [],
    referralList: [],
    avatarList: [],
    avatarColorList: [],
  },
  mutations: {
    setAgencyList(state, records) {
      state.agencyList = records;
    },
    setCityList(state, records) {
      state.cityList = records;
    },
    setProvinceList(state, records) {
      state.provinceList = records;
    },

    setGenderList(state, records) {
      state.genderList = records;
    },
    setEthnoList(state, records) {
      state.ethnoList = records;
    },
    setAgeList(state, records) {
      state.ageList = records;
    },
    setReferralList(state, records) {
      state.referralList = records;
    },
    setAvatarList(state, records) {
      state.avatarList = records;
    },
    setAvatarColorList(state, records) {
      state.avatarColorList = records;
    },
  },
};
